module.exports = __webpack_public_path__ + "r-v3/img/ml_21_00.1b3e54b5.jpg";